import Fuse from "fuse.js";
import moment from "moment";
import { FaPlus } from "react-icons/fa";
import CardHeader from "../../atoms/CardHeader";
import IconButton from "../../atoms/IconButton";
import Card from "../../atoms/Card";
import QuejasYReportesTable from "../../organisms/inmueble/inmuebleDocsTables/QuejasYReportesTable";
import Modal from "../../molecules/Modal";
import CreateQYR from "../../organisms/inmueble/inmuebleDocsTables/quejas_reportes/CreateQYR";
import { useCallback, useEffect, useState } from "react";
import useModal from "../../../hooks/useModal";
import { useSession } from "../../../context/SessionContext";
import { GET_QUEJAS_REPORTES } from "../../../api/apiFiles";
import FilterQYR from "../../organisms/inmueble/inmuebleDocsTables/quejas_reportes/FilterQYR";
import { getInmobiliaria } from "../../../utils/getInmobiliaria";
import { GET_INMUEBLE_ID } from "../../../api/apiInmuebles";
import { useParams } from "react-router-dom";
import Breadcrumb from "../../molecules/Breadcrumb";

const InmuebleQYRTemplate = () => {
    const { user } = useSession();
    const { idUser, id, im } = useParams();
    const [inmueble, setInmueble] = useState();
    const [loading, setLoading] = useState();
    const [quejasReportes, setQuejasReportes] = useState();
    const [filteredQuejasReportes, setFilteredQuejasReportes] = useState();
    const { open, isOpen, close } = useModal();
    const [filters, setFilters] = useState({
        description: "",
        incidentRange: { start: "", end: "" },
        serviceRange: { start: "", end: "" },
        status: "",
    });

    const getQuejas_Reportes = useCallback ( async () => {
        setLoading(true);
        try {
            const quejasReportesData = await GET_QUEJAS_REPORTES(Number(im));
            setQuejasReportes(quejasReportesData);
            setFilteredQuejasReportes(quejasReportesData);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, [im]);

    const getInmueble = useCallback ( async () => {
        if (!im) return;
        try {
                const inmuebleData = await GET_INMUEBLE_ID(Number(im));
                setInmueble(inmuebleData);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        }, [im]);

    useEffect(() => {
        getQuejas_Reportes();
    }, [getQuejas_Reportes]);

    useEffect(() => {
        if (!im) return;
        getInmueble();
    },[getInmueble, im]);

    useEffect(() => {
        if (!quejasReportes) return;

        let result = [...quejasReportes];

        if (filters.description) {
            const fuse = new Fuse(result, {
                keys: ["description"],
                threshold: 0.3,
            });
            result = fuse.search(filters.description).map(res => res.item);
        }

        if (filters.incidentRange.start && filters.incidentRange.end) {
            result = result.filter(qr => {
                const date = moment(qr.incident_date);
                return (
                    date.isSameOrAfter(moment(filters.incidentRange.start)) &&
                    date.isSameOrBefore(moment(filters.incidentRange.end))
                );
            });
        }

        if (filters.serviceRange.start && filters.serviceRange.end) {
            result = result.filter(qr => {
                const date = moment(qr.service_date);
                return (
                    date.isSameOrAfter(moment(filters.serviceRange.start)) &&
                    date.isSameOrBefore(moment(filters.serviceRange.end))
                );
            });
        }

        if (filters.status) {
            if (filters.status === "Pendiente") {
                result = result.filter(qr => !qr.service_date);
            } else if (filters.status === "Resuelto") {
                result = result.filter(qr => qr.service_date);
            }
        }

        setFilteredQuejasReportes(result);
    }, [filters, quejasReportes]);

    const linksAdmin = [
        { label: "Inmobiliarias", to: "/inmobiliarias" },
        { label: getInmobiliaria(id), to: `/inmobiliarias/${id}` },
        { label: inmueble?.name, to: `/inmobiliarias/${id}/${im}` },
        { label: "Quejas y reportes", to: null },
    ];

    const linksUser = [
        { label: inmueble?.name, to: `/${idUser}/${im}` },
        { label: "Quejas y reportes", to: null },
    ];

    return(
        <div className="flex flex-col gap-4">
            <CardHeader
                left={
                    <Breadcrumb
                        items={user?.role === "Resident" ? linksUser : linksAdmin}
                    />
                }
                right={user?.role === "Resident" && !loading ?
                        <IconButton icon={FaPlus} bgColor="bg-green-600" onClick={open}/>
                    :
                        <IconButton icon={FaPlus} bgColor="bg-white" disabled/>
                }
            />
            <Card>
                <FilterQYR filters={filters} setFilters={setFilters} />
                <QuejasYReportesTable data={filteredQuejasReportes} loading={loading} refetch={getQuejas_Reportes} />
            </Card>
            {isOpen &&
                <Modal title="Reportar" onClose={close}>
                    <CreateQYR onClose={close} refetch={getQuejas_Reportes} />
                </Modal>
            }
        </div>
    );
};

export default InmuebleQYRTemplate;